<template>
  <div class="relative">
    <div class="pt-24 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Individuals</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Wellwisher</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/cp-bg-l.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/w-swpr4.svg"
              class="w-full absolute top6rem min-h-86per -left-8 md:block lg:block hidden"
              alt=""
            />
            <img
              src="../../../assets/images/swiper-img/ww-mob-2.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full mr-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
            >
              <p
                class="lg:text-xl md:text-xl sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 cursor-pointer"
              >
                <i>
                  “I was meeting her almost after eight months since her mother
                  got diagnosed. Her face was pale…. she had lost weight…I could
                  feel she is troubled with thoughts. I was not sure what to
                  tell her…” <br />– Shwetha, 44 yrs, well-wisher of her friend.
                </i>
              </p>
              <br />
              <p
                class="font-semibold fsize27 sm-fsize26 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Want to aid somebody struggling with their caregiving role?
                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('community')"
                >
                  Learn How
                </span>
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="padding btntext"
                  @click="handleClick('community')"
                  >Learn How</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide class="">
        <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per relative">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-28 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-PCDx6_uJs2sxQTi-UKi6J-1733403815"
              class="md:hidden h-250px object-cover custborderradius lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <div class="">
              <p
                class="lg:text-xl md:text-xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 cursor-pointer mob-hidden"
              >
                <i class="text-primary">
                  “I was meeting her after eight months since her mother got
                  diagnosed. Her face was pale…. she had lost weight…I could
                  feel she was troubled with thoughts. I was not sure what to
                  tell her…” </i
                ><br />– Shwetha, 44 yrs, well-wisher of her friend
              </p>
              <br />
              <p
                class="font-semibold fsize27 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Want to support a family or friend who is a caregiver?
              </p>
              <p
                class="fsize25 sm-fsize14 md-fsize18 font-normal lg:pt-6 md:pt-6 pt-3 lh32px sm-lh20"
              >
                You can gift them a service or encourage them to join our
                community. Learn how you can support them as a well-wisher

                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('product-services')"
                >
                  Buy Now
                </span>
              </p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick('product-services')"
                  >Discover</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-PCDx6_uJs2sxQTi-UKi6J-1733403815"
              class="m-auto object-cover custborderradius"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per relative">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px absolute right-0 bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative lg:mt-0 md:mt-0 mt-3 md:hidden lg:hidden block"
          >
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-WyP4K2AJnXkcUgAMsaZ2d-1733403615"
              class="md:hidden object-cover custborderradius lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize35 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Be the LIGHT in the path of a caregiver
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Learn how to give emotional first aid or provide respite care.
                Join us to know how you can contribute to their caregiving

                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  v-b-modal.modal-1
                >
                  Sign Up
                </span>
              </p>
              <div class="lg:pt-8 md:pt-8 pt-4">
                <base-button
                  type="primary"
                  @click="handleClick('insights-blogs')"
                  class="padding-wellwishbtn btntext mob-hidden"
                  >Explore</base-button
                >
              </div>
              <!-- <div class="flex pt-8" v-b-modal.modal-1>
                <b-modal
                  class="bg-primary"
                  id="modal-1"
                  ref="form-model"
                  title="Subscribe to our newsletters"
                  hide-footer
                >
                  <div class="">
                    <validation-observer
                      v-slot="{ handleSubmit }"
                      ref="formValidator"
                    >
                      <b-form v-on:submit.prevent="handleSubmit(submitForm)">
                        <b-form-group
                          id="input-group-1"
                          label="Email:"
                          label-for="input-1"
                          class="mb-4"
                        >
                          <base-input
                            v-model="email"
                            id="input-1"
                            :rules="{ required: true, email: true }"
                            name="Email"
                            placeholder="Enter your email"
                            class="mb-4"
                          ></base-input>
                        </b-form-group>

                        <b-form-group
                          id="input-group-2"
                          label="Your phone number:"
                          label-for="input-2"
                          class="mt-4"
                        >
                          <base-input
                            :rules="{
                              numeric: true,
                              min: 10,
                              max: 15,
                            }"
                            id="input-2"
                            name="Mobile"
                            v-model="mobile"
                            placeholder="Enter phone number"
                            class="mb-4"
                          ></base-input>
                        </b-form-group>

                        <div class="text-center mt-4">
                          <b-button type="submit" variant="primary" class=""
                            >Submit</b-button
                          >
                        </div>
                      </b-form>
                    </validation-observer>
                  </div>
                </b-modal>
              </div> -->
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/banner/image-WyP4K2AJnXkcUgAMsaZ2d-1733403615"
              class="m-auto custborderradius"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="">
        <!-- <div class="absolute bg-design-s2tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2tr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2tr.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design-s2rr mob-hidden">
          <img
            src="../../../assets/images/bg-des/s2rr.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s2e2 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e2.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="bg-white h-640px"
          />
        </div>
        <div
          class="lg:px-20 md:px-20 px-5 lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-36 custflexdirection"
        >
          <!-- <img
            src="../../../assets/images/cp-bg-l.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-3">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Well-wisher/Banner3.jpg"
              class="custborderradius m-auto md:block lg:block hidden"
              alt=""
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Well-wisher/Banner3.jpg"
              class="md:hidden object-cover custborderradius lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:m-5 md:m-5">
            <div class="">
              <p
                class="font-semibold fsize48 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug w-full"
              >
                Support Groups to SHARE and HEAL
              </p>
              <p
                class="lg:text-2xl md:text-2xl md-fsize18 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20 cursor-pointer"
              >
                Encourage a caregiver to empower herself/himself by being part
                of our safe space to share their feelings

                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('community')"
                >
                  Identify Solutions
                </span>
              </p>
              <div class="flex pt-8 mob-hidden">
                <a href="https://chat.whatsapp.com/H4TUoGPJGIpJJ3b5NXHUNe">
                  <base-button
                    type="primary"
                    class="padding-wellwishbtn btntext"
                  >
                    Join our support group
                  </base-button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3rlt.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="
              lg:w-1/2
              md:w-1/2
              w-full
              relative
              md:hidden
              lg:hidden
              block
              lg:top-0
              md:top-0
              top-72
            "
          >
            <img
              src="../../../assets/images/swiper-img/ww-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="
                lg:w-5/6
                md:w-5/6
                w-full
                ml-auto
                lg:pt-0
                md:pt-0
                pt-24
                lg:px-0
                md:px-0
                px-6
              "
            >
              <p
                class="
                  font-semibold
                  fsize48
                  sm-fsize24
                  line-h60
                  letter-s016px
                  text-black
                  leading-snug
                  w-full
                "
              >
                RISE by lifting others.
              </p>
              <p
                class="
                  lg:text-2xl
                  md:text-2xl
                  sm-fsize14
                  font-normal
                  lg:pt-6
                  md:pt-6
                  pt-3
                  lh40px
                  sm-lh20
                  ellipsis-3
                "
              >
                This is your chance to Gift a service to your loved one.
                <span class="underline text-4f0a4b min-hidden font-semibold"
                  >Know more</span
                >
              </p>
              <div class="flex pt-8 mob-hidden">
                <base-button type="primary" class="padding btntext"
                  >Know more</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              src="../../../assets/images/cp-bg.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/w-swpr3.svg"
              class="
                w-full
                absolute
                top6rem
                min-h-86per
                md:block
                lg:block
                hidden
              "
              alt="swiper-img"
            />
            <img
              src="../../../assets/images/swiper-img/ww-mob-3.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
        </div>
      </swiper-slide> -->
      <div class="swiper-button-prev homeswiper" slot="button-prev"></div>
      <div class="swiper-button-next homeswiper" slot="button-next"></div>

      <div
        class="swiper-pagination dot-shift1 cust-posi"
        slot="pagination"
      ></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        // autoplay: {
        //   delay: 12000,
        //   disableOnInteraction: false,
        // },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleScroll() {
      const el = document.getElementById("SolutionDiv");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    async submitForm() {
      let payload = {
        email: this.email,
      };

      if (!isNaN(parseInt(this.mobile))) {
        Object.assign(payload, { mobile: parseInt(this.mobile) });
      }

      // console.log(payload);

      try {
        const data = await this.$store.dispatch(
          "newsletter/createNewsletter",
          payload
        );

        if (data.code == 200) {
          this.$swal.fire({
            text: "Subscribed Successfully!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.email = "";
          this.mobile = "";
          this.$refs["form-model"].hide();
          this.$refs.formValidator.reset();
        }
      } catch (error) {
        payload = {};
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
  },
};
</script>
<style>
.modal-title {
  font-size: 24px !important;
  color: white;
}
.modal-header {
  background: #4f0a4b;
}
.dot-shift1 {
  bottom: 10px !important;
  width: 100%;
  justify-content: center;
  display: flex;
  gap: 6px;
}
@media (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .swiper-button-next {
    right: 25px !important;
  }

  .swiper-button-prev {
    left: 25px !important;
  }
}
@media (max-width: 640px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
  .z-ind1 {
    z-index: -1;
  }
  .h-250px {
    height: 250px;
  }
}
</style>
